import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  TextField,
  Typography,
  Button,
  IconButton,
  DialogContent,
  DialogTitle,
  Dialog,
  FormHelperText,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import ListReqTakeOut from "./ListReqTakeOut";
import { UPDATE_TAKE_OUT } from "../../Schema/TakeOut";
// import { SelectOffice } from "../Include/DynamicSelect";
import { SelectUser } from "../Include/DynamicSelect";

export default function UpdateReqTakeOut({
  editData,
  open,
  handleClose,
  setRefetch,
  dialogTitle,
}) {
  // console.log("editData", editData);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [selectOffice, setSelectedOffice] = useState({ id: "", title: "" });
  const [selectUser, setSelecteUser] = useState({
    _id: "",
    title: "",
    profileImage: "",
  });

  const [requireField, setRequireField] = useState(false);
  const listReqTakeOutMaterial = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    qty: 0,
    key: Date.now() + Math.random(),
  };
  const [listTakeOutData, setListTakeOutData] = useState([
    listReqTakeOutMaterial,
  ]);
  // console.log("listTakeOutData", listTakeOutData);
  const handleAddReqTakeOut = () => {
    setListTakeOutData([...listTakeOutData, listReqTakeOutMaterial]);
  };
  const handleUpdateReqTakeOut = (key, val, fieldName) => {
    const newListTakeOutData = listTakeOutData?.map((d) => {
      if (val === null) {
        if (key === d.key && fieldName === "materialId") {
          d.materialId = { id: "", title: "" };
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
      } else {
        if (key === d.key && fieldName === "materialId") {
          d.listMaterialUnitId.id = "";
          d.listMaterialUnitId.title = "";
          d.materialId = val;
        }
        if (key === d.key && fieldName === "listMaterialUnitId")
          d.listMaterialUnitId = val;
        if (key === d.key && fieldName === "qty") d.qty = val;
      }
      return d;
    });
    setListTakeOutData(newListTakeOutData);
  };
  const handleDeleteListReqTakeOut = (key) => {
    const handleDeleteList = listTakeOutData?.filter((d) => d.key !== key);
    setListTakeOutData([...handleDeleteList]);
  };

  //updateReqTakeOut
  const [updateReqTakeOut] = useMutation(UPDATE_TAKE_OUT, {
    onCompleted: ({ updateReqTakeOut }) => {
      setLoading(false);
      if (updateReqTakeOut?.status) {
        setAlert(true, "success", updateReqTakeOut?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", updateReqTakeOut?.message);
        // console.log("error");
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });
  //formik
  const CheckValidation = Yup.object().shape({
    userId: Yup.string().required("require!"),
    remark: Yup.string(),
  });
  const formik = useFormik({
    initialValues: {
      userId: "",
      remark: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("vlaues", values);
      let createStatus = false;
      const BreakException = {};
      try {
        listTakeOutData?.forEach(function (elem) {
          if (
            elem?.materialId?.id !== undefined &&
            elem?.materialId?.id !== "" &&
            elem?.listMaterialUnitId?.id !== undefined &&
            elem?.listMaterialUnitId?.id !== "" &&
            elem?.qty > 0
          ) {
            createStatus = true;
          } else {
            setLoading(false);
            setRequireField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }
      if (createStatus) {
        let listReqTakeOutMaterialToSubmit = listTakeOutData?.map((d) => {
          // console.log("d", d);
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            qty: parseFloat(d?.qty),
          };
        });
        setLoading(true);
        updateReqTakeOut({
          variables: {
            id: editData?._id,
            input: {
              userId: values?.userId,
              reqTakeOutMaterial: listReqTakeOutMaterialToSubmit,
              remark: values?.remark,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("remark", editData?.remark ?? "");
      setSelecteUser({
        _id: editData?.userId?._id,
        title: editData?.userId?.mainUserId?.firstName + ' ' +editData?.userId?.mainUserId?.lastName,
        profileImage: editData?.userId?.officeId?.officeKhName,
      });
      setFieldValue("userId", editData?.userId?._id);
    }

    if (editData?.reqTakeOutMaterial?.length !== 0) {
      const dataFromBackend = editData?.reqTakeOutMaterial?.map((d) => {
        return {
          key: Date.now() + Math.random(),
          materialId: {
            id: d?.listMaterialUnitId?.materialId?._id,
            title: d?.listMaterialUnitId?.materialId?.materialEnName,
          },
          listMaterialUnitId: {
            id: d?.listMaterialUnitId?._id,
            title: d?.listMaterialUnitId?.unitId?.unitKhName,
            imageSrc: d?.listMaterialUnitId?.imageSrc,
          },
          qty: d?.qty,
        };
      });
      // console.log("dataFromBackend::", dataFromBackend)
      setListTakeOutData([...dataFromBackend]);
    }
  }, [editData, open]);
  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              បង្កើតសំណើរផ្ទេរចេញ
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={4}>
                <Typography className="field-title">
                  អ្នកតំណាងការិយាល័យ
                </Typography>
                <SelectUser
                  selectedVal={selectUser}
                  setSelectedVal={setSelecteUser}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  touched={touched}
                />
              </Grid>
              <Grid item xs={12}>
                <ListReqTakeOut
                  handleDeleteList={handleDeleteListReqTakeOut}
                  handleUpdateList={handleUpdateReqTakeOut}
                  handleAddList={handleAddReqTakeOut}
                  requiredField={requireField}
                  listTakeOutData={listTakeOutData}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">កំណត់សម្គាល់</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    បង្កើត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
